import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import daDK from '../locales/da-DK/translations.json';
import enGB from '../locales/en-GB/translations.json';
import fiFI from '../locales/fi-FI/translations.json';
import svSE from '../locales/sv-SE/translations.json';
import { Locale } from './i18nUtils';

const defaultLocale = Locale.enGB;

export const resources = {
  [Locale.fiFI]: {
    translations: fiFI,
  },
  [Locale.svSE]: {
    translations: svSE,
  },
  [Locale.daDK]: {
    translations: daDK,
  },
  [Locale.enGB]: {
    translations: enGB,
  },
} as const;

i18n.use(initReactI18next).init({
  fallbackLng: defaultLocale,
  resources,
  ns: ['translations'],
  defaultNS: 'translations',
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

i18n.languages = [Locale.fiFI, Locale.svSE, Locale.daDK, Locale.enGB];

export default i18n;
